module.exports = __webpack_public_path__ + "static/img/huojiadili.402c2eeb.jpg";